import React, { createContext, useContext, useState } from 'react';
import { Statement } from '../dtos';

type State = {
    statements: Statement[];
    setStatements: React.Dispatch<React.SetStateAction<Statement[]>>;
};

type Props = {
    children: React.ReactNode;
};

const StatementContext = createContext<State>({} as State);

const StatementProvider: React.FC<Props> = ({ children }) => {
    const [statements, setStatements] = useState<Statement[]>([]);

    return (
        <StatementContext.Provider
            value={{
                statements,
                setStatements,
            }}
        >
            {children}
        </StatementContext.Provider>
    );
};

const useStatement = (): State => {
    const context = useContext(StatementContext);

    return context;
}

export { StatementProvider, useStatement };